import { render, staticRenderFns } from "./pc_common.vue?vue&type=template&id=ddf927a6"
import script from "./pc_common.vue?vue&type=script&lang=js"
export * from "./pc_common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports